import Contentpage from 'components/Content/Content';
import { withContentProps } from 'viewModel/content/withContentProps';

export default withContentProps(Contentpage);
